import { createContext } from "react";

const MetaContext = createContext();

export default MetaContext;